@for (alertMessage of this.alertMessages; track alertMessage) {
  <app-alert-message [alertMessage]="alertMessage"></app-alert-message>
}

